// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__FYXd8","small":"small__MdaJH","bordered":"bordered__3oHNu"};